export const SCOPE = 'aiAlerts';
export const INIT = `${SCOPE}/INIT`;
export const RESET = `${SCOPE}/RESET`;
